import React, { Component } from 'react';
import PagesModul from './DifferentThemes/PagesModul';
import AccordeonModul from './DifferentThemes/AccordeonModul';
import TabsModul from './DifferentThemes/TabsModul';
import DataStore from '../stores/DataStore';

/** s
 * Modul, welches die Anzeige der Themen in Form eines der Themenarten zuständig ist.
 */
class ThemesModul extends Component {
  constructor(params) {
    super(params);
    this.state = {};
  }

  /**
   * gibt die passende Klasse zum thema in den props gegeben zurück.
   * @returns {class} passendes Modul wie z.b. pagesModul,AkkordeinModul,..
   */
  getModul() {
    const {
      themesOptions: { displayStyle = 'pages' },
    } = this.props;
    switch (displayStyle) {
      case 'pages': {
        return PagesModul;
      }
      case 'tabs': {
        return TabsModul;
      }
      case 'accordeon': {
        return AccordeonModul;
      }
      default: {
        return PagesModul;
      }
    }
  }

  /**
   * Modul, welches die Anzeige der Themen in Form eines der Themenarten zuständig ist.
   * Öffnet, je nach Typ, eines der verschiedenen Themenanzeigen.
   * @render
   * @param {object} this.state
   * @param {object} this.props.themesOption
   * @param {string} [this.props.themesOption.displayStyle="pages"]  - Titel des Themas
   * @param {Array} [this.props.themesOption.themes=[]] - Array der Einzelthemen
   * @param {Array} [this.props.themesOption.attributes] - Array mit Attributen, wenn keine Themenunterteilung vorliegt
   */
  render() {
    const {
      themesOptions: { themes = [], attributes = [] },
      editToolbar,
    } = this.props;
    this.requestHandler = DataStore.getHandler().requestHandler;
    this.messageHandler = DataStore.getHandler().messageHandler;
    this.messageHandler.logDebugFormatted(
      'ThemesModul',
      'render',
      '',
      this.props,
      this.state,
    );
    const Modul = this.getModul();
    return (
      <Modul
        themes={themes}
        attributes={attributes}
        editToolbar={editToolbar}
      />
    );
  }
}
export default ThemesModul;
